import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';

export interface BlogCardProps {
  slug: string;
  title: string;
  date: string;
  excerpt: string;
  category: string;
  imageUrl?: string;
  featured?: boolean;
}

const BlogCard: React.FC<BlogCardProps> = ({ slug, title, date, excerpt, category, imageUrl }) => {
  return (
    <Link to={`/blog/${slug}`} className="group block h-full">
      <article className="flex h-full flex-col">
        <div className="relative mb-6 aspect-[4/3] overflow-hidden rounded-2xl bg-slate-100">
          {imageUrl ? (
            <img src={imageUrl} alt={title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-slate-100 text-slate-300">
              <span className="text-4xl font-extrabold opacity-20">LL</span>
            </div>
          )}
          <Badge className="absolute left-4 top-4 border-none bg-white/90 px-3 font-medium text-slate-900 shadow-sm backdrop-blur hover:bg-white">{category}</Badge>
        </div>

        <div className="flex flex-grow flex-col">
          <div className="mb-3 text-xs font-medium uppercase tracking-wide text-slate-500">
            {new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </div>
          <h3 className="mb-3 text-2xl font-bold leading-tight text-slate-900 transition-colors group-hover:text-slate-700">{title}</h3>
          <p className="mb-6 line-clamp-3 flex-grow leading-relaxed text-slate-600">{excerpt}</p>
          <div className="group/link mt-auto flex items-center text-sm font-medium text-slate-900">
            Read Article <ArrowRight size={16} className="ml-2 transition-transform group-hover/link:translate-x-1" />
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
